import type { ICloudStorageHeaders } from '@picsart/cloud-storage/types/models/api/headers';

import { getContext } from '@/context';
import { NotificationType } from '@/types';
import { showNotification } from '@/utils/ui/showNotification';

export const getCloudStorageHeaders = (): ICloudStorageHeaders => {
  return getContext().utils.api.getHeaders() as ICloudStorageHeaders;
};

export const withCloudStorageErrorHandling = async <T>(
  operation: () => Promise<T>,
  errorMessage: string
): Promise<T | null> => {
  try {
    return await operation();
  } catch {
    showNotification({ title: errorMessage, type: NotificationType.ERROR });
    return null;
  }
};
